<mat-form-field style="height: 72px">
  <mat-label>Select {{ type }}</mat-label>
  <mat-select (selectionChange)="selectedResult($event.value)" [(ngModel)]="defaultResult">
    <mat-option *ngFor="let result of scalarResults" [value]="result.id">
      {{ result.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
